var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Control/hide",
    transform: "translate(-3.000000, -4.000000)",
    fill: "#6E6E6E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9019734,4.32665842 C18.0861582,4.14247359 18.4151632,4.172856 18.6368267,4.39451943 L18.6368267,4.39451943 L19.4478533,5.2055461 C19.6695168,5.42720953 19.6998992,5.75621455 19.5157143,5.94039938 L19.5157143,5.94039938 L6.17586889,19.2802448 C5.99168406,19.4644297 5.66267904,19.4340472 5.44101561,19.2123838 L5.44101561,19.2123838 L4.62998894,18.4013571 C4.40832551,18.1796937 4.3779431,17.8506887 4.56212793,17.6665039 L4.56212793,17.6665039 L6.30645052,15.9237246 C5.20681232,15.0821859 4.22060825,14.0169423 3.43006564,12.7882938 L3.25,12.5 L2.95,12 L3.25,11.5 C5.15,8.1 8.45,6 11.95,6 C13.1479656,6 14.3327529,6.26356688 15.4613059,6.76678064 Z M18.180275,8.5453589 C19.007024,9.28081648 19.7707389,10.1654904 20.4472702,11.1859643 L20.65,11.5 L21.05,12.1 L20.65,12.6 C18.45,16 15.15,18 11.95,18 C11.0340498,18 10.1103956,17.8305122 9.21111222,17.5150581 L10.8364188,15.8901391 C11.2096703,15.9624198 11.5821839,16 11.95,16 C14.35,16 16.85,14.5 18.65,12.1 C18.0794991,11.2759431 17.4386803,10.5623857 16.7530143,9.97206324 L18.180275,8.5453589 Z M14.9428677,11.7830991 C14.9475987,11.8546129 14.95,11.926937 14.95,12 C14.95,13.7 13.65,15 11.95,15 C11.876594,15 11.8039339,14.9975761 11.732092,14.9928009 L14.9428677,11.7830991 Z M11.95,8 C9.35,8 6.85,9.5 5.25,12 C5.94948551,12.987509 6.80134195,13.8395771 7.72894228,14.5004756 L9.14116915,13.0873209 C9.01725304,12.7526338 8.95,12.3866635 8.95,12 C8.95,10.3 10.25,9 11.95,9 C12.3362822,9 12.701912,9.06712046 13.0363306,9.1908027 L13.9058919,8.32205965 C13.257186,8.11000109 12.5999263,8 11.95,8 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hide.cec68ee13413242640fdbce4de05f3fb.svg";